class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// PC ドロップダウン 3階層目：ネストされた details の開閉
// header-menu の外側にある Details-HeaderSubMenu-* を処理
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="Details-HeaderSubMenu-"]').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    // 親の details が閉じたら子も閉じる
    const parentDetails = details.closest('[id^="Details-HeaderMenu-"]');
    if (parentDetails) {
      parentDetails.addEventListener('toggle', () => {
        if (!parentDetails.open) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // フォーカスが外れたら閉じる
    details.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!details.contains(document.activeElement)) {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // summary クリックで aria-expanded を同期
    summary.addEventListener('click', () => {
      setTimeout(() => {
        summary.setAttribute('aria-expanded', String(details.open));
      });
    });
  });
});

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._isHovered = false;
    this._closeTimer = null;

    this.addEventListener('mouseover', (e) => {
      this._isHovered = true;
      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
    });

    this.addEventListener('mouseout', (e) => {
      if (!this.contains(e.relatedTarget)) {
        this._isHovered = false;
        this._closeTimer = setTimeout(() => {
          if (!this._isHovered && !this.contains(document.activeElement)) {
            this.close();
          }
        }, 200);
      }
    });
  }

  onFocusOut() {
    // focusoutは遅延を長めにとり、ホバー状態を優先する
    setTimeout(() => {
      if (this._isHovered) return;
      if (!this.contains(document.activeElement)) this.close();
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
